import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { hotelreview, selectHotelReview, selectsaveitinerary, saveitinerary, selectReviewLoading } from "./HotelSlice";
import countrycode from "../../data/countrycode.json";
import { selectCurrentUser } from "../auth/authSlice";
import { toast } from 'react-hot-toast';
import CancellationPolicyPopup from './CancellationPolicyPopup';
import BookingReviewShimmer from './BookingReviewShimmer';
import { useNavigate } from 'react-router-dom';
const HotelCheckout = () => {
    const navigate = useNavigate()
    const [openRedirectPopup, setopenRedirectPopup] = useState(false);
    const user = useSelector(selectCurrentUser)
    const location = useLocation();
    const dispatch = useDispatch();
    const selectreviewData = useSelector(selectHotelReview);
    const ReviewLoading = useSelector(selectReviewLoading);
    const selectsaveitineraryResponse = useSelector(selectsaveitinerary);
    const [memberDetails, setmemberDetails] = useState([]);
    const HotelDetails = selectreviewData && selectreviewData.status.success && selectreviewData.HotelDetails
    const searchQuery = selectreviewData && selectreviewData.status.success && selectreviewData.searchQuery.searchQuery
    const RoomInfos = selectreviewData && selectreviewData.status.success && selectreviewData.RoomInfo
    const fares = selectreviewData && selectreviewData.status.success && selectreviewData.fare
    const CurrencySymbol = selectreviewData && selectreviewData.status.success && selectreviewData.searchQuery.searchQuery.searchCriteria.currency || "INR"
    const [showCancellationPopup, setShowCancellationPopup] = useState(true);
    const [selectedRoomGroup, setSelectedRoomGroup] = useState(null);
    // const BookingId = selectreviewData && selectreviewData.status.success && selectreviewData.searchId
    const [BookingId, setBookingId] = useState([]);
    const [allNationalities] = useState(countrycode);
    const [initialNationalities] = useState(countrycode.slice(0, 10));
    const [showNationalityDropdown, setShowNationalityDropdown] = useState(false);
    const [filteredNationalities, setFilteredNationalities] = useState([]);
    const [modifyFormData, setModifyFormData] = useState({
        countryCode: "91",
        nationality: "India",
        email: user && user.UserData.email,
        mobile: user && user.UserData.mobile,
        gstnnumber: null,
        companyname: null,
        gstemail: null,
        gstphone: null,
        gstaddress: null,
        isgstapply: null,
        specialrequest: "na",
        accepttnc: false,
    });

    useEffect(() => {
        setopenRedirectPopup(false)
        if (selectreviewData && !selectreviewData?.status?.success) {
            setopenRedirectPopup(true)
        }
        if (selectreviewData?.travellers) {
            setmemberDetails(selectreviewData.travellers);
        } else {
            setmemberDetails([]);
        }
    }, [selectreviewData]);
    const handleNationalityInputChange = (e) => {

        const value = e.target.value;
        setModifyFormData(prev => ({
            ...prev,
            nationality: value
        }));

        if (value) {
            const filtered = allNationalities.filter(country =>
                country.name.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredNationalities(filtered);
        } else {
            setFilteredNationalities(initialNationalities);
        }
    };
    const handleNationalityFocus = () => {
        setShowNationalityDropdown(true);
        if (!modifyFormData.nationality) {
            setFilteredNationalities(initialNationalities);
        } else {
            const filtered = allNationalities.filter(country =>
                country.name.toLowerCase().includes(modifyFormData.nationality.toLowerCase())
            );
            setFilteredNationalities(filtered);
        }
    };
    const handleNationalitySelect = (country) => {
        setModifyFormData(prev => ({
            ...prev,
            nationality: country.name,
            countryCode: country.dial_code
        }));
        setShowNationalityDropdown(false);
    };
    const calculatePaxCounts = (data) => {
        if (!data || !Array.isArray(data)) {
            return { adults: 0, children: 0, infants: 0 };
        }

        const counts = data.reduce((acc, roomGroup) => {
            if (roomGroup.Rooms && Array.isArray(roomGroup.Rooms)) {
                roomGroup.Rooms.forEach(room => {
                    acc.adults += room.Adult || 0;
                    acc.children += room.Child || 0;
                    acc.infants += room.Infant || 0;
                });
            }
            return acc;
        }, { adults: 0, children: 0, infants: 0 });

        return counts;
    };
    const paxCounts = calculatePaxCounts(selectreviewData && selectreviewData.status.success && selectreviewData.RoomInfo);


    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const parts = location.pathname.split("/").filter(Boolean);
        const bookingId = parts[parts.length - 3];
        const requestId = parts[parts.length - 2];
        const RoomId = parts[parts.length - 1];
        const reviewHash = searchParams.get("reviewHash");
        setBookingId(bookingId)
        FetchDetails({
            FormData: {
                Request: {
                    correlationId: bookingId,
                    hid: requestId,
                    reviewHash: reviewHash,
                    optionId: RoomId
                },
                BookingID: bookingId,
                currency: {
                    CurrencyRate: "1.000000",
                    CurrencyTitle: "INR",
                    CurrencyId: 1
                }
            }
        });


    }, [location.pathname]);

    const handleFormChange = (event, roomIndex, passengerIndex) => {
        const { name, value } = event.target;
        setmemberDetails(prevDetails =>
            prevDetails.map((room, rIndex) =>
                rIndex === roomIndex
                    ? room.map((passenger, pIndex) =>
                        pIndex === passengerIndex
                            ? { ...passenger, [name]: value }
                            : passenger
                    )
                    : room
            )
        );
    }
    const alphacheck = (e) => {
        const regex = /[A-Za-z ]/;
        const chars = e.target.value.split('');
        const char = chars.pop();
        if (!regex.test(char)) {
            e.target.value = chars.join('');
            toast.error('Please enter only alphabets', { autoclose: toasterTimer });
            e.preventDefault();
            return false;
        } else {
            return true;
        }
    }
    const toasterTimer = 2000;
    const onKeyPress = (e) => {
        let input = e.target;
        if (e.charCode < 47 || e.charCode > 57) {
            e.preventDefault();
        }
        var len = input.value.length;
        if (len !== 1 || len !== 3) {
            if (e.charCode == 47) {
                e.preventDefault();
            }
        }

        if (len === 2) {
            input.value += '/';
        }

        if (len === 5) {
            input.value += '/';
        }
    }
    const createsavepax = () => {
        let continueform = true;
        let regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        try {

            if (modifyFormData.country === '') {
                toast.error('Please Select Country ', { autoclose: toasterTimer });
                continueform = false;
                throw new Error("Break the loop.");
            }
            if (modifyFormData.mobile === '') {
                toast.error('Please Enter mobile number', { autoclose: toasterTimer });
                continueform = false;
                throw new Error("Break the loop.");
            }
            if (modifyFormData.email === '') {
                toast.error('Please Enter email ID', { autoclose: toasterTimer });
                continueform = false;
                return false;
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(modifyFormData.email)) {
                toast.error('Please Enter valid email ID', { autoclose: toasterTimer });
                continueform = false;
                return false;
            }

            memberDetails.forEach((value, keys) => {
                value.forEach((vl, key) => {
                    let paxmsg = 'of ROOM ' + (keys + 1) + ' guest ' + (key + 1);
                    if (vl.title === '') {
                        toast.error('Select title ' + paxmsg, { autoclose: toasterTimer });
                        continueform = false;
                        throw new Error("Break the loop.");

                    }

                    if (vl.fname === '') {
                        toast.error('Enter first name ' + paxmsg, { autoclose: toasterTimer });
                        continueform = false;
                        throw new Error("Break the loop.");

                    }
                    const regMatch = /^[a-zA-Z ]*$/.test(vl.fname);
                    if (!regMatch) {
                        toast.error('Please enter first name only alphabets ' + paxmsg, { autoclose: toasterTimer });
                        continueform = false;
                        throw new Error("Break the loop.");
                    }
                    const fname = vl.fname.trim();
                    if (fname.length < 3) {
                        toast.error('Length of last name should be between 3 to 32 alphabets for guest. ' + paxmsg, { autoclose: toasterTimer });
                        continueform = false;
                        throw new Error("Break the loop.");
                    }
                    if (vl.lname === '') {
                        toast.error('Enter last name ' + paxmsg, { autoclose: toasterTimer });
                        continueform = false;
                        throw new Error("Break the loop.");

                    }
                    const regMatch2 = /^[a-zA-Z ]*$/.test(vl.lname);
                    if (!regMatch2) {
                        toast.error('Please enter last name only alphabets ' + paxmsg, { autoclose: toasterTimer });
                        continueform = false;
                        throw new Error("Break the loop.");
                    }
                    const lname = vl.lname.trim();
                    if (lname.length < 3) {
                        toast.error('Length of first name should be between 3 to 32 alphabets for guest. ' + paxmsg, { autoclose: toasterTimer });
                        continueform = false;
                        throw new Error("Break the loop.");
                    }
                    if (vl.IsPAN) {
                        if (vl.panno === '') {
                            toast.error('Enter PAN number ' + paxmsg, { autoclose: toasterTimer });
                            continueform = false;
                            throw new Error("Break the loop.");

                        }
                        if (!regpan.test(vl.panno)) {
                            toast.error('Enter valid PAN number ' + paxmsg, { autoclose: toasterTimer });
                            continueform = false;
                            throw new Error("Break the loop.");

                        }
                    }
                    if (vl.IsPassM) {
                        if (vl.passno === '') {
                            toast.error('Enter Passpost number ' + paxmsg, { autoclose: toasterTimer });
                            continueform = false;
                            throw new Error("Break the loop.");

                        }
                        if (vl.passisse === '') {
                            toast.error('Enter Issue date ' + paxmsg, { autoclose: toasterTimer });
                            continueform = false;
                            throw new Error("Break the loop.");

                        }
                        if (vl.passexp === '') {
                            toast.error('Enter Expiry date ' + paxmsg, { autoclose: toasterTimer });
                            continueform = false;
                            throw new Error("Break the loop.");

                        }
                    }
                })
            })
        } catch (error) {
        }
        if (!continueform) {
            return false
        }
        return {
            memberDetails: memberDetails,
            data: modifyFormData,
            BookingID: BookingId,
            BookingType: 2,
            customer_id: user?.UserData?.user?.id,
            currency: {
                CurrencyRate: "1",
                CurrencyTitle: "INR",
                CurrencyId: 1
            }
        };
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.nationality-input-container')) {
                setShowNationalityDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    // Usage
    const SavePax = async (payload) => {
        try { await dispatch(saveitinerary(payload)).unwrap(); }
        catch (err) { console.error("Fetch failed:", err); }
    };

    const [isSubmitted, setIsSubmitted] = useState(false);
    const handlesubmit = async () => {
        const dataArr = createsavepax();

        if (dataArr) {
            setIsSubmitted(true);
            await SavePax({ FormData: dataArr });

        }
    };
    useEffect(() => {
        if (isSubmitted && selectsaveitineraryResponse?.status?.success) {
            const EncBookingID = selectsaveitineraryResponse?.BookingID;
            window.location.href = `/hotel/payment/${BookingId}`;
        } else if (isSubmitted && !selectsaveitineraryResponse?.status?.success) {
            {
                selectsaveitineraryResponse &&
                    toast.error(selectsaveitineraryResponse && selectsaveitineraryResponse?.message && selectsaveitineraryResponse?.message)
            }
        }
    }, [selectsaveitineraryResponse, isSubmitted]);
    const FetchDetails = async (payload) => {
        try { await dispatch(hotelreview(payload)).unwrap(); }
        catch (err) { console.error("Fetch failed:", err); }
    };
    const handlePreferenceChange = (text, isChecked) => {
        const key = text.toLowerCase().replace(/\s+/g, '');
        setModifyFormData(prev => ({
            ...prev,
            [key]: isChecked ? text : ''
        }));
    };
    return (
        <div className="max-w-7xl mx-auto p-6 bg-gray-50 min-h-screen">
            {ReviewLoading ? (
                <> <BookingReviewShimmer /></>
            ) : (
                <>
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                        <div className="lg:col-span-2 space-y-6 ">
                            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                                <h1 className="text-2xl font-bold text-gray-900 mb-6">Review your Booking</h1>

                                <div className="mb-6">
                                    <h2 className="text-xl font-semibold text-gray-900 mb-1">{HotelDetails && HotelDetails.name}</h2>
                                    <p className="text-gray-600 text-sm mb-2">
                                        {HotelDetails && HotelDetails?.ad?.adr},  {HotelDetails && HotelDetails?.ad?.adr2} {HotelDetails && HotelDetails?.ad?.postalCode},{HotelDetails && HotelDetails?.ad?.ctn}, {HotelDetails && HotelDetails?.ad?.cn}
                                    </p>

                                </div>

                                <div className="grid grid-cols-2 gap-6 mb-6">
                                    <div>
                                        <h3 className="text-sm font-semibold text-gray-700 mb-2">CHECK IN</h3>
                                        <div className="text-gray-900">
                                            <div className="font-medium">{searchQuery && searchQuery.checkinDate}</div>
                                            <div className="text-sm">12 PM</div>
                                        </div>
                                    </div>
                                    <div>
                                        <h3 className="text-sm font-semibold text-gray-700 mb-2">CHECK OUT</h3>
                                        <div className="text-gray-900">
                                            <div className="font-medium">{searchQuery && searchQuery.checkoutDate}</div>
                                            <div className="text-sm">11 AM</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="text-sm text-gray-600 mb-6">
                                    {fares && fares.nightCoun} Nights | {paxCounts.adults} Adults, {paxCounts.children} Children | {fares && fares.roomCoun} Rooms
                                </div>

                                <hr className="border-gray-300 mb-6" />


                                {RoomInfos && RoomInfos.length > 0 && RoomInfos[0].Rooms[0] && (() => {
                                    const roomGroup = RoomInfos[0];
                                    const room = roomGroup.Rooms[0];

                                    return (
                                        <div className={`flex gap-4 p-4 border rounded-lg cursor-pointer transition-all duration-200 border-gray-200 hover:border-gray-400`}>

                                            <div className="flex-1">
                                                <div className="mb-2">
                                                    <h3 className="font-semibold text-lg">{room.RoomType}</h3>
                                                    <p className="text-gray-600 text-sm">
                                                        {room.MealBase} • {roomGroup.IsPan ? "PAN required" : "No PAN required"}
                                                    </p>
                                                </div>

                                                <div className="flex flex-wrap gap-4 mb-3">
                                                    {room.Extrabenefits && room.Extrabenefits.map((benefit, benefitIdx) => (
                                                        <div key={benefitIdx} className="flex items-center text-green-600 text-sm">
                                                            <i className="fas fa-check mr-1"></i>
                                                            <span>{benefit}</span>
                                                        </div>
                                                    ))}
                                                </div>

                                                <div className="flex justify-between items-center pt-3 border-t border-gray-200">
                                                    <div className="text-sm text-gray-600">
                                                        <span>{room.rooms || 1} Room(s)</span>
                                                        <span className="mx-2">•</span>
                                                        <span>{room.nights || roomGroup.Nights || 1} Night(s)</span>
                                                    </div>

                                                    <div className="flex items-center gap-4">
                                                        <div className="text-right">
                                                            <p className="font-semibold text-lg">{CurrencySymbol} {room.HotelRoomPrice * room.rooms || room.pernightperroomprice * room.rooms}</p>
                                                            {/* <button className="text-blue-600 text-sm font-medium hover:text-blue-800 mt-1">
                                                        Cancellation Policy
                                                    </button> */}
                                                            {showCancellationPopup && roomGroup && (
                                                                <CancellationPolicyPopup
                                                                    cancellationData={roomGroup.CancelArr}
                                                                    currencySymbol={CurrencySymbol}
                                                                    onClose={() => setShowCancellationPopup(false)}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })()}
                                <hr className="border-gray-300 mb-6" />

                                <div className="mb-6">
                                    <h2 className="text-xl font-semibold text-gray-900 mb-4">
                                        Traveler Details - Login to book faster
                                    </h2>

                                    <div className="mb-4">
                                        <h3 className="font-medium text-gray-700 mb-3">Contact Details</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                                            <div className="flex flex-col flex-1 min-w-[200px] nationality-input-container relative">
                                                <label className="text-xs text-gray-500 mb-1">Country</label>
                                                <input
                                                    type="text"
                                                    value={modifyFormData?.nationality || ""}
                                                    onChange={handleNationalityInputChange}
                                                    onFocus={handleNationalityFocus}
                                                    placeholder="Enter Nationality"
                                                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                />
                                                {showNationalityDropdown && (
                                                    <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
                                                        {filteredNationalities.length === 0 ? (
                                                            <div className="px-4 py-2 text-gray-500 text-center">
                                                                No nationalities found
                                                            </div>
                                                        ) : (
                                                            filteredNationalities.map(country => (
                                                                <div
                                                                    key={country.code}
                                                                    onClick={() => handleNationalitySelect(country)}
                                                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-gray-200 last:border-b-0"
                                                                >
                                                                    + {country.dial_code} {country.name}
                                                                </div>
                                                            ))
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="flex items-end gap-4">
                                                {/* Mobile Input */}
                                                <div className="flex flex-col flex-1 min-w-[200px]">
                                                    <label className="text-gray-600 mb-1 block">Mobile</label>
                                                    <input
                                                        type="tel"
                                                        value={modifyFormData.mobile}
                                                        onChange={(e) => setModifyFormData(prev => ({
                                                            ...prev,
                                                            mobile: e.target.value
                                                        }))}
                                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                        placeholder="Enter mobile number"
                                                    />
                                                </div>

                                                {/* Email Input */}
                                                <div className="flex flex-col flex-1 min-w-[200px]">
                                                    <label className="text-gray-600 mb-1 block">Email ID</label>
                                                    <input
                                                        type="email"
                                                        value={modifyFormData.email}
                                                        onChange={(e) => setModifyFormData(prev => ({
                                                            ...prev,
                                                            email: e.target.value
                                                        }))}
                                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                        placeholder="Enter email address"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                                <h1 className="text-2xl font-bold text-gray-900 mb-6">Travelers Details</h1>

                                <div className="px-2 pb-2">
                                    {memberDetails &&
                                        memberDetails.length > 0 &&
                                        memberDetails.map((item, key) => (
                                            <div
                                                className="mb-6 border border-gray-200 rounded-xl overflow-hidden"
                                                key={key}
                                            >
                                                {/* Room Header */}
                                                <div className="font-bold text-lg bg-gray-100 p-3 rounded-t-xl border-b border-gray-200">
                                                    Room {key + 1}
                                                </div>

                                                {item.map((items, keys) => (
                                                    <div
                                                        className="p-5 border-b border-gray-100 last:border-b-0"
                                                        key={keys + 'keys'}
                                                    >
                                                        <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
                                                            {/* Pax Label */}
                                                            <div className="md:col-span-3 flex flex-col justify-center">
                                                                <div className="bg-gray-50 px-4 py-3 rounded-lg text-center border border-gray-100">
                                                                    <h5 className="font-semibold text-gray-900 mb-0">
                                                                        {items.pax} {items.PaxCount}
                                                                    </h5>
                                                                </div>
                                                            </div>

                                                            {/* Pax Info Text */}
                                                            <div className="md:col-span-9 flex items-center text-sm text-gray-600">
                                                                (Details same as your identification document)
                                                            </div>

                                                            {/* Title */}
                                                            <div className="md:col-span-2">
                                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                    Title
                                                                </label>
                                                                {items.PaxType == 1 ? (
                                                                    <select
                                                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                                        name="title"
                                                                        onChange={(event) => handleFormChange(event, key, keys)}
                                                                        id={key + '_' + items.index + 'salution'}
                                                                        index={items.index}
                                                                    >
                                                                        <option value="">Title</option>
                                                                        <option value="Mr">Mr</option>
                                                                        <option value="Mrs">Mrs</option>
                                                                        <option value="Ms">Ms</option>
                                                                    </select>
                                                                ) : (
                                                                    <select
                                                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                                        name="title"
                                                                        onChange={(event) => handleFormChange(event, key, keys)}
                                                                        id={key + '_' + items.index + 'salution'}
                                                                        index={items.index}
                                                                    >
                                                                        <option value="">Title</option>
                                                                        <option value="Miss">Miss</option>
                                                                        <option value="Master">Master</option>
                                                                    </select>
                                                                )}
                                                            </div>

                                                            {/* First & Middle Name */}
                                                            <div className="md:col-span-3">
                                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                    First & Middle Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 uppercase"
                                                                    value={items.fname}
                                                                    name="fname"
                                                                    id={key + '_' + items.index + 'fname'}
                                                                    onKeyPress={alphacheck}
                                                                    placeholder="First & Middle Name"
                                                                    onChange={(event) => {
                                                                        event.target.value = event.target.value.toUpperCase();
                                                                        handleFormChange(event, key, keys);
                                                                    }}
                                                                />
                                                            </div>

                                                            {/* Last Name */}
                                                            <div className="md:col-span-3">
                                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                    Last Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 uppercase"
                                                                    value={items.lname}
                                                                    name="lname"
                                                                    id={key + '_' + items.index + 'lname'}
                                                                    onKeyPress={alphacheck}
                                                                    placeholder="Last Name"
                                                                    onChange={(event) => {
                                                                        event.target.value = event.target.value.toUpperCase();
                                                                        handleFormChange(event, key, keys);
                                                                    }}
                                                                />
                                                            </div>

                                                            {/* Child Age */}
                                                            {items.PaxType == 2 && (
                                                                <div className="md:col-span-2">
                                                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                        Child Age
                                                                    </label>
                                                                    <input
                                                                        disabled
                                                                        readOnly
                                                                        value={`Age: ${items.Age}`}
                                                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-100 text-gray-600"
                                                                    />
                                                                </div>
                                                            )}

                                                            {/* PAN Number */}
                                                            {items.IsPAN && (
                                                                <div className="md:col-span-12">
                                                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                        Pan card Number
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 uppercase"
                                                                        value={items.panno}
                                                                        name="panno"
                                                                        id={key + '_' + items.index + 'panno'}
                                                                        placeholder="Pan Card Number"
                                                                        onChange={(event) => {
                                                                            event.target.value = event.target.value.toUpperCase();
                                                                            handleFormChange(event, key, keys);
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}

                                                            {/* Passport Fields */}
                                                            {items.IsPassM && (
                                                                <>
                                                                    <div className="md:col-span-4">
                                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                            Passport Number
                                                                        </label>
                                                                        <input
                                                                            maxLength="10"
                                                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                                            type="text"
                                                                            value={items.passno}
                                                                            onChange={(event) => handleFormChange(event, key, keys)}
                                                                            id={key + '_' + items.index + 'passno'}
                                                                            name="passno"
                                                                            placeholder="Passport Number"
                                                                        />
                                                                    </div>

                                                                    <div className="md:col-span-4">
                                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                            Issue Date
                                                                        </label>
                                                                        <input
                                                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                                            type="text"
                                                                            value={items.passisse}
                                                                            onChange={(event) => handleFormChange(event, key, keys)}
                                                                            onKeyPress={onKeyPress}
                                                                            id={key + '_' + items.index + 'passisse'}
                                                                            name="passisse"
                                                                            placeholder="Passport Issue Date"
                                                                        />
                                                                    </div>

                                                                    <div className="md:col-span-4">
                                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                            Expiry Date
                                                                        </label>
                                                                        <input
                                                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                                            type="text"
                                                                            value={items.passexp}
                                                                            onChange={(event) => handleFormChange(event, key, keys)}
                                                                            onKeyPress={onKeyPress}
                                                                            id={key + '_' + items.index + 'passexp'}
                                                                            name="passexp"
                                                                            placeholder="Passport Expiry Date"
                                                                        />
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                </div>





                                {/* <div className="px-2 pb-2">
                                    {memberDetails && memberDetails.length > 0 && memberDetails.map((item, key) => (
                                        <div className="mb-4 border border-gray-200 rounded-lg" key={key}>
                                            <div className="font-bold text-lg bg-gray-100 p-3 rounded-t-lg">
                                                Room {key + 1}
                                            </div>

                                            {item.map((items, keys) => (
                                                <div className="p-4 border-b border-gray-100 last:border-b-0" key={keys + 'keys'}>
                                                    <div className="grid grid-cols-1 md:grid-cols-12 gap-4">

                                                        <div className={"md:col-span-3 mb-2"}>
                                                            <div className="bg-gray-50 p-3 rounded-lg text-center">
                                                                <h5 className="font-semibold text-gray-900 mb-0">
                                                                    {items.pax} {items.PaxCount}
                                                                </h5>
                                                            </div>
                                                        </div>

                                                        <>
                                                            <div className="md:col-span-9 text-sm text-gray-600 mb-4">
                                                                (Details same as your identification document)
                                                            </div>
                                                            <div className="md:col-span-3"></div>
                                                        </>


                                                        <div className="md:col-span-2">
                                                            {(
                                                                <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
                                                            )}
                                                            {items.PaxType == 1 ? (
                                                                <select
                                                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                                    name='title'
                                                                    onChange={event => handleFormChange(event, key, keys)}
                                                                    id={key + "_" + items.index + "salution"}
                                                                    index={items.index}
                                                                >
                                                                    <option value="">Title</option>
                                                                    <option value="Mr">Mr</option>
                                                                    <option value="Mrs">Mrs</option>
                                                                    <option value="Ms">Ms</option>
                                                                </select>
                                                            ) : (
                                                                <select
                                                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                                    name='title'
                                                                    onChange={event => handleFormChange(event, key, keys)}
                                                                    id={key + "_" + items.index + "salution"}
                                                                    index={items.index}
                                                                >
                                                                    <option value="">Title</option>
                                                                    <option value="Miss">Miss</option>
                                                                    <option value="Mstr">Master</option>
                                                                </select>
                                                            )}
                                                        </div>

                                                        <div className="md:col-span-3">
                                                            {(
                                                                <label className="block text-sm font-medium text-gray-700 mb-1">First & Middle Name</label>
                                                            )}
                                                            <input
                                                                type="text"
                                                                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                                value={items.fname}
                                                                name='fname'
                                                                id={key + "_" + items.index + "fname"}
                                                                onKeyPress={alphacheck}
                                                                placeholder="First & Middle Name"
                                                                onChange={event => {
                                                                    event.target.value = event.target.value.toUpperCase();
                                                                    handleFormChange(event, key, keys);
                                                                }}
                                                            />
                                                        </div>

                                                        <div className="md:col-span-3">
                                                            {(
                                                                <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                                                            )}
                                                            <input
                                                                type="text"
                                                                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                                value={items.lname}
                                                                name='lname'
                                                                id={key + "_" + items.index + "lname"}
                                                                onKeyPress={alphacheck}
                                                                placeholder="Last Name"
                                                                onChange={event => {
                                                                    event.target.value = event.target.value.toUpperCase();
                                                                    handleFormChange(event, key, keys);
                                                                }}
                                                            />
                                                        </div>

                                                        {items.PaxType == 2 && (
                                                            <div className="md:col-span-2">
                                                                {(
                                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Child Age</label>
                                                                )}
                                                                <input
                                                                    disabled
                                                                    readOnly
                                                                    value={`Age: ${items.Age}`}
                                                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-100 text-gray-600"
                                                                />
                                                            </div>
                                                        )}

                                                        {items.IsPAN && (
                                                            <div className={"md:col-span-10"}>
                                                                {(
                                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Pan card Number</label>
                                                                )}
                                                                <input
                                                                    type="text"
                                                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                                    value={items.panno}
                                                                    name='panno'
                                                                    id={key + "_" + items.index + "panno"}
                                                                    placeholder={`Pan Card Number `}
                                                                    onChange={event => {
                                                                        event.target.value = event.target.value.toUpperCase();
                                                                        handleFormChange(event, key, keys);
                                                                    }}
                                                                />
                                                            </div>
                                                        )}

                                                        {items.IsPassM && (
                                                            <div className={`${items.IsPAN ? "md:col-span-5 md:col-start-3" : "mt-2"}`}>
                                                                {(
                                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Passport Number</label>
                                                                )}
                                                                <input
                                                                    maxLength="10"
                                                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                                    type="text"
                                                                    value={items.passno}
                                                                    onChange={event => handleFormChange(event, key, keys)}
                                                                    id={key + "_" + items.index + "passno"}
                                                                    name='passno'
                                                                    placeholder={`Passport Number }`}
                                                                />
                                                            </div>
                                                        )}

                                                        {items.IsPassM && (
                                                            <div className="md:col-span-5 md:col-start-3 mt-2">
                                                                {(
                                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Issue Date</label>
                                                                )}
                                                                <input
                                                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                                    type="text"
                                                                    value={items.passisse}
                                                                    onChange={event => handleFormChange(event, key, keys)}
                                                                    index={keys}
                                                                    room={key}
                                                                    onKeyPress={onKeyPress}
                                                                    id={key + "_" + items.index + "passisse"}
                                                                    name='passisse'
                                                                    placeholder="Passport Issue Date"
                                                                />
                                                            </div>
                                                        )}

                                                        {items.IsPassM && (
                                                            <div className="md:col-span-5 mt-2">
                                                                {(
                                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Expiry Date</label>
                                                                )}
                                                                <input
                                                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                                    index={keys}
                                                                    room={key}
                                                                    type="text"
                                                                    value={items.passexp}
                                                                    onChange={event => handleFormChange(event, key, keys)}
                                                                    onKeyPress={onKeyPress}
                                                                    id={key + "_" + items.index + "passexp"}
                                                                    name='passexp'
                                                                    placeholder="Passport Expiry Date"
                                                                />
                                                            </div>
                                                        )}

                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div> */}

                                <hr className="border-gray-300 mb-6" />

                                <div className="mb-6">
                                    <h2 className="text-lg font-semibold text-gray-900 mb-4">Special Request(s) (Optional)</h2>

                                    <h3 className="font-medium text-gray-700 mb-3">Commonly Requested</h3>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
                                        <label className="flex items-center gap-2 text-sm text-gray-700">
                                            <input
                                                type="checkbox"
                                                className="rounded border-gray-300"
                                                checked={modifyFormData.smokingroom || false}
                                                onChange={(e) => handlePreferenceChange('Smoking room', e.target.checked)}
                                            />
                                            Smoking room
                                        </label>
                                        <label className="flex items-center gap-2 text-sm text-gray-700">
                                            <input
                                                type="checkbox"
                                                className="rounded border-gray-300"
                                                checked={modifyFormData.latecheckin || false}
                                                onChange={(e) => handlePreferenceChange('Late check in', e.target.checked)}
                                            />
                                            Late check-in
                                        </label>
                                        <label className="flex items-center gap-2 text-sm text-gray-700">
                                            <input
                                                type="checkbox"
                                                className="rounded border-gray-300"
                                                checked={modifyFormData.earlycheckin || false}
                                                onChange={(e) => handlePreferenceChange('Early check in', e.target.checked)}
                                            />
                                            Early check-in
                                        </label>
                                        <label className="flex items-center gap-2 text-sm text-gray-700">
                                            <input
                                                type="checkbox"
                                                className="rounded border-gray-300"
                                                checked={modifyFormData.roomonahighfloor || false}
                                                onChange={(e) => handlePreferenceChange('Room on a high floor', e.target.checked)}
                                            />
                                            Room on a high floor
                                        </label>
                                        <label className="flex items-center gap-2 text-sm text-gray-700">
                                            <input
                                                type="checkbox"
                                                className="rounded border-gray-300"
                                                checked={modifyFormData.largebed || false}
                                                onChange={(e) => handlePreferenceChange('Large bed', e.target.checked)}
                                            />
                                            Large bed
                                        </label>
                                        <label className="flex items-center gap-2 text-sm text-gray-700">
                                            <input
                                                type="checkbox"
                                                className="rounded border-gray-300"
                                                checked={modifyFormData.twinbeds || false}
                                                onChange={(e) => handlePreferenceChange('Twin beds', e.target.checked)}
                                            />
                                            Twin beds
                                        </label>
                                        <label className="flex items-center gap-2 text-sm text-gray-700">
                                            <input
                                                type="checkbox"
                                                className="rounded border-gray-300"
                                                checked={modifyFormData.airporttransfer || false}
                                                onChange={(e) => handlePreferenceChange('Airport transfer', e.target.checked)}
                                            />
                                            Airport transfer
                                        </label>
                                    </div>


                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Any other request?
                                        </label>
                                        <textarea onChange={(e) => setModifyFormData(prev => ({
                                            ...prev,
                                            specialrequest: e.target.value
                                        }))}
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm h-20"
                                            placeholder="Enter any other special requests..."
                                        />
                                    </div>
                                </div>

                                <hr className="border-gray-300 mb-6" />

                                <div className="mb-6">
                                    <p className="text-sm text-gray-600 mb-4">
                                        By proceeding, I agree to the Website Terms of Service and Cancellation & Property Booking Policies.
                                    </p>

                                    <button className="w-full py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors" onClick={handlesubmit} disabled={isSubmitted}>
                                        {isSubmitted ? "Processing..." : "Continue"}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="lg:col-span-1 ">
                            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sticky top-6">

                                <div>
                                    <h2 className="text-xl font-semibold text-gray-900 mb-4">Fare Details</h2>

                                    <div>
                                        <div className="text-sm text-gray-600 mb-4">{fares && fares.roomCoun} Room(s) x {fares && fares.nightCoun} Night(s)</div>
                                        <div className="space-y-3 mb-4">
                                            <div className="flex justify-between text-sm">
                                                <span className="text-gray-600">Base Fare</span>
                                                <span className="text-gray-900 font-medium">{fares && fares.symbol} {fares && fares.BaseFare}</span>
                                            </div>
                                            <div className="flex justify-between text-sm">
                                                <span className="text-gray-600">Hotel Taxes</span>
                                                <span className="text-gray-900 font-medium">{fares && fares.symbol} {fares && fares.TaxesandFee}</span>
                                            </div>
                                            <div className="flex justify-between text-sm">
                                                <span className="text-gray-600">Convenience Fee</span>
                                                <span className="text-gray-900 font-medium">{fares && fares.symbol} {(fares && fares.FixedMarkUp + fares && fares.GSTOnMarkUp)}</span>
                                            </div>
                                            {fares.TotalAgentMarkup > 0 && (
                                                <div className="flex justify-between text-sm">
                                                    <span className="text-gray-600">Your Markup</span>
                                                    <span className="text-gray-900 font-medium">{fares && fares.symbol} {(fares && fares.TotalAgentMarkup)}</span>
                                                </div>
                                            )}
                                            {fares.Discount > 0 && (
                                                <div className="flex justify-between text-sm">
                                                    <span className="text-gray-600">Discount</span>
                                                    <span className="text-gray-900 font-medium">{fares && fares.symbol} {(fares && fares.Discount)}</span>
                                                </div>
                                            )}

                                            <div className="flex justify-between text-sm border-t border-gray-200 pt-3">
                                                <span className="text-gray-800 font-medium">Price after Discount</span>
                                                <span className="text-gray-900 font-medium">{fares && fares.symbol} {fares && fares.GrandTotal + fares.TotalAgentMarkup}</span>
                                            </div>
                                        </div>

                                        <hr className="border-gray-300 my-4" />

                                        <div className="flex justify-between items-center">
                                            <span className="font-semibold text-gray-900 text-lg">Total Amount</span>
                                            <span className="text-xl font-bold text-gray-900">{CurrencySymbol} {fares && fares.GrandTotal + fares.TotalAgentMarkup}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="flex flex-col gap-3 mt-8 pt-6 border-t border-gray-300">
                            <button className="w-full py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors">
                                Proceed to Pay
                            </button>
                            <button className="w-full py-3 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors">
                                Back
                            </button>
                        </div> */}

                                <div className="text-xs text-gray-500 text-center mt-6">
                                    <div className="mb-1">CHECKIN : 12:00 PM / CHECKOUT : 11:00 AM</div>
                                    <div className="text-gray-400">Last Booked - 18 hours ago</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {openRedirectPopup && (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                            <div className="bg-white p-6 rounded-xl shadow-lg w-80 text-center">
                                <h2 className="text-lg font-semibold mb-4">
                                    This Room Is Taken
                                </h2>
                                <p className="text-sm text-gray-600 mb-6">
                                    Great rooms go fast! Search again to discover other available options for your stay.
                                </p>
                                <div className="flex justify-center gap-3">
                                    <a
                                        href={'/hotel'}
                                        className="px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-medium shadow transition"
                                    >
                                        {'Click Here to Search Again'}
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}
                </>

            )}
        </div>
    );
};

export default HotelCheckout;